import "./InnerSpinnerLoading.scss";

const InnerSpinnerLoading = ({ isLoading }) => {
  return <div className={`"spinner" ${isLoading ? "active" : ""}`}></div>;
};

export default InnerSpinnerLoading;
